import { DataAccessService } from "./basic.service";

class TabletGroupsDAService extends DataAccessService {

    constructor(collectionName: string) {
        super(collectionName)
    }
}
export default new TabletGroupsDAService('tablet_groups');